module.exports = __webpack_public_path__ + "img/1981-850x510-dreadnaught-arizona.21fb9213.jpg";